export const gitCommit = '818f007f'
